import _extends from "@babel/runtime/helpers/extends";
import { vueUtils } from '../utils';
import xxOpenData from '../utils/xxOpenData';
var openData = xxOpenData.openData;
export default {
  name: 'YxtbizOpenData',
  props: {
    /**
     * 开放数据类型
     * type 的合法值 userName: 用户名称 departmentName: 部门名称
     */
    type: String,

    /**
     * 若 type=userName，此时 openid 对应 userid
     * 若 type=departmentName，此时 openid 对应 departmentid
     */
    openid: String
  },
  watch: {
    // 获取到接口数据再渲染列表，openid初始就有值，所以watch不会触发，需要再mounted执行更新
    openid: function openid(_openid) {
      if (_openid) {
        var _this$$el;

        // 人员离职后，钉钉无法返回用户名/部门名, dt-open-data为空白
        // 若xx-open-data元素在列表/表格行中被复用，被复用的xx-open-data元素openid变了，但是shadowroot没更新，造成信息错乱
        // 所以openid变化，先清空shadowroot的原有用户名
        if (openData.isMyAttachShadow && (_this$$el = this.$el) != null && _this$$el.shadowRoot) {
          var firstChild = this.$el.shadowRoot.childNodes[0];

          if (firstChild) {
            firstChild.textContent = '';
          }
        } // openData.debUpdate(this.$el);


        openData.debUpdate();
      }
    }
  },
  mounted: function mounted() {
    // document.querySelectorAll('ww-open-data') 并不能得到全量的open-data节点
    // 因为有的 ww-open-data 被tooltip包装，并没有渲染到页面上
    openData.addElement(this.$el);

    if (!openData.isStarted()) {
      openData.init();
    } else {
      if (openData.isReady()) {
        openData.debUpdate(this.$el);
      }
    }
  },
  updated: function updated() {
    openData.addElement(this.$el); // 若ww-open-data, 加key, 需要在渲染完后，才能得到最新元素
  },
  render: function render(h) {
    h = vueUtils.geth(h);
    return h('xx-open-data', _extends({}, openData.isMyAttachShadow ? {} : {
      key: this.openid
    }, {
      attrs: {
        type: this.type,
        openid: this.openid
      }
    }));
  }
};